// Port of api/fuel/app/classes/model/platform/externaldomain.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'platform_externaldomain',
	prefix: 'externaldomain',
	key: 'externaldomain_id',
	fields: {
		externaldomain_id: Model.SCHEMA_KEY,
		user_id: Model.SCHEMA_NUMBER,
		externaldomain_date: Model.SCHEMA_DATE_CREATE,
		externaldomain_status: Model.SCHEMA_NUMBER,
		externaldomain_type: Model.SCHEMA_NUMBER,
		externaldomain_recipient: Model.SCHEMA_NUMBER,
		externaldomain_value: Model.SCHEMA_TEXT
	}
})
